import {
  GetAccountNonce as GetAccountNonceXdc3,
  IsAddress as IsAddressXdc,
  ToEthAddress,
  GetAccountBalance as GetAccountBalanceXdc3,
} from "../utilities/xdc3.js";
import {
  GetAccountNonce as GetAccountNonceWeb3,
  IsAddress as IsAddressEth,
  GetAccountBalance as GetAccountBalanceWeb3,
} from "../utilities/web3";
import { isAddress } from "ethers/lib/utils";
import { GetBitcoinBalance } from "./bitcoin.js";
import { GetXrpBalance } from "./xrp.js";
import { GetSolanaBalance } from "./solana.js";
import bitcore from "bitcore-lib";

export const BlockchainType = {
  ethereum: "ethereum",
  xinfin: "xinfin",
  bitcoin: "bitcoin",
  solana: "solana",
  xrp: "xrp",
};

export const GetBlockchainType = (address = "") => {
  if (address.startsWith("xdc")) return BlockchainType.xinfin;
  if (address.startsWith("0x")) return BlockchainType.ethereum;
  return "invalid";
};

export const GetBlockchainFromChainId = (chainId) => {
  switch (`${chainId}`) {
    // Mainnet
    case "50":
      return BlockchainType.xinfin;
    case "1":
      return BlockchainType.ethereum;
    case "0":
      return BlockchainType.bitcoin;
    case "101":
      return BlockchainType.solana;
    case "144":
      return BlockchainType.xrp;

    // Testnet
    case "51":
      return BlockchainType.xinfin;
    case "11155111": // Sepolia
      return BlockchainType.ethereum;
    case "3":
      return BlockchainType.bitcoin;
    case "103":
      return BlockchainType.solana;
    case "142":
      return BlockchainType.xrp;

    default:
      return null;
  }
};

export const GetNonce = async (address, type, chainId = null) => {
  switch (type) {
    case BlockchainType.ethereum: {
      return await GetAccountNonceWeb3(address, { chainId });
    }
    case BlockchainType.xinfin: {
      return await GetAccountNonceXdc3(address, { chainId });
    }
    case BlockchainType.bitcoin:
      return null;
    case BlockchainType.solana:
      return null; // Solana doesn't use nonces like Ethereum
    case BlockchainType.xrp:
      return null; // XRP uses sequence numbers, handled separately
    default:
      return null;
  }
};

export const GetBalance = async (address, type, chainId = null) => {
  switch (type) {
    case BlockchainType.ethereum: {
      return await GetAccountBalanceWeb3(address, chainId);
    }
    case BlockchainType.xinfin: {
      return await GetAccountBalanceXdc3(address, { chainId });
    }
    case BlockchainType.bitcoin: {
      return await GetBitcoinBalance(address, chainId);
    }
    case BlockchainType.xrp: {
      return await GetXrpBalance(address, chainId);
    }
    case BlockchainType.solana: {
      return await GetSolanaBalance(address, chainId);
    }
    default:
      break;
  }
};

export const IsValid = (address = "") => {
  return IsAddressEth(address) || IsAddressXdc(ToEthAddress(address));
};

// Helper functions to determine network type
export const IsTestnetChainId = (chainId) => {
  const testnetChainIds = [51, 11155111, 103, 142, 3];
  return testnetChainIds.includes(parseInt(chainId));
};

export const IsMainnetChainId = (chainId) => {
  const mainnetChainIds = [50, 1, 101, 144, 0];
  return mainnetChainIds.includes(parseInt(chainId));
};

// Add this
/* export const IsValid = (address = "") => {
  const isEthOrXdc =
    IsAddressEth(address) || IsAddressXdc(ToEthAddress(address));
  const isBitcoin = bitcore.Address.isValid(address);
  return isEthOrXdc || isBitcoin;
}; */
